import { Injectable } from '@angular/core';
import { ICallcardTool } from '../../schema/interfaces/ICallcardButtonTool';

@Injectable({
  providedIn: 'root'
})
export class ButtonsProviderService {
  private _buttons: ICallcardTool[] = [];
  get buttons(): ICallcardTool[] {
    return this._buttons;
  }

  constructor() {}

  add(button: ICallcardTool) {
    this._buttons.push(button);
    this._buttons.sort((a, b) => a.position - b.position);
  }

  remove(button: ICallcardTool) {
    const idx = this._buttons.indexOf(button);
    if (idx > -1) {
      this._buttons.splice(idx, 1);
    }
  }
}
